module.exports = __webpack_public_path__ + "img/terroir-charcoal-4.82c18279.jpg";